import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { ChevronDown, ChevronRight } from "../icons/v2-stroke";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
import { Icon } from "./Icon";
const labelVariants = cva("s-inline-flex s-transition-colors s-ease-out s-duration-400 s-box-border s-gap-x-2 s-select-none s-text-sm", {
    variants: {
        variant: {
            primary: "s-text-highlight-600 dark:s-text-highlight-600-night",
            secondary: "s-text-foreground dark:s-text-foreground-night",
        },
        disabled: {
            true: "s-text-muted dark:s-text-muted-night",
            false: "group-hover/col:s-text-highlight-500 dark:group-hover/col:s-text-highlight-500-night active:s-text-highlight-700 dark:active:s-text-highlight-700-night",
        },
    },
    defaultVariants: {
        variant: "primary",
        disabled: false,
    },
});
const chevronVariants = cva("s-transition-transform s-duration-150", {
    variants: {
        variant: {
            primary: "s-text-muted-foreground dark:s-text-muted-foreground-night",
            secondary: "s-text-muted-foreground dark:s-text-muted-foreground-night",
        },
        disabled: {
            true: "s-text-muted dark:s-text-muted-night",
            false: "group-hover/col:s-text-highlight-500 dark:group-hover/col:s-text-highlight-500-night active:s-text-highlight-700 dark:active:s-text-highlight-700-night",
        },
    },
    defaultVariants: {
        variant: "primary",
        disabled: false,
    },
});
const Collapsible = React.forwardRef(({ children, className, ...props }, ref) => (React.createElement(CollapsiblePrimitive.Root, { ref: ref, className: className, ...props }, children)));
Collapsible.displayName = "Collapsible";
const CollapsibleTrigger = React.forwardRef(({ label, children, className, disabled = false, hideChevron = false, variant = "primary", ...props }, ref) => {
    return (React.createElement(CollapsiblePrimitive.Trigger, { ref: ref, disabled: disabled, className: cn("s-group/col s-flex s-w-full s-items-center s-gap-1 focus:s-outline-none focus:s-ring-0", disabled ? "s-cursor-default" : "s-cursor-pointer", className), ...props },
        !hideChevron && (React.createElement("span", { className: cn("s-transition-transform s-duration-200", chevronVariants({ variant, disabled })) },
            React.createElement(Icon, { visual: ChevronRight, size: "sm", className: "s-block group-data-[state=open]/col:s-hidden" }),
            React.createElement(Icon, { visual: ChevronDown, size: "sm", className: "s-hidden group-data-[state=open]/col:s-block" }))), children !== null && children !== void 0 ? children : (React.createElement("span", { className: labelVariants({ variant, disabled }) }, label))));
});
CollapsibleTrigger.displayName = "CollapsibleTrigger";
const contentVariants = cva("s-overflow-hidden s-transition-all", {
    variants: {
        variant: {
            default: "s-text-foreground dark:s-text-foreground-night",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
const CollapsibleContent = React.forwardRef(({ children, className, variant, ...props }, ref) => (React.createElement(CollapsiblePrimitive.Content, { ref: ref, className: cn(contentVariants({ variant }), "data-[state=closed]:s-animate-collapse-up data-[state=open]:s-animate-collapse-down", className), ...props }, children)));
CollapsibleContent.displayName = "CollapsibleContent";
export { Collapsible, CollapsibleContent, CollapsibleTrigger };
//# sourceMappingURL=Collapsible.js.map